import {
  ComponentLabel,
  UiZoneWidgetConfig,
  WorkflowWidgetConfig,
} from '@finxone-platform/shared/sys-config-types';

export const mapBackButtonWidgetFunction = function mapBackButtonWidget(
  item: WorkflowWidgetConfig,
): UiZoneWidgetConfig {
  const elementsConfig = item.widgetConfiguration.attributes?.elementsConfig;

  return {
    name: item.name as ComponentLabel,
    attributes: {
      backgroundShape: elementsConfig.find((item) => item.field_name === 'backgroundShape')?.show ?? true,
      ...item.widgetConfiguration.attributes,
    },
    uniqueId: item.uniqueId,
    gridPosition: item.gridPosition,
  };
};
